<template>
    <div class="blog-wrapper bg-rothcoCream">
        <Head>
            <title>{{pageName}}</title>
            <meta name="description" :content="content?.data?.metaDescription"/>
            <meta name="keywords" :content="content?.data?.metaKeywords"/>
        </Head>
        <div id="blogPage">
            <div class="flex flex-row" style="justify-content: space-between; padding: 1rem">
                <p id="blogType">{{blogType}}</p>
                <Link :href="route('blog.landing')">Back</Link>
            </div>
            <h1 style="padding: 1rem;" class="title-xl">{{pageName}}</h1>
            <cms content-prop="content" model="content-section" :url="url" driver="builder" v-model="builderData" :readable-fields="['blogType', 'pageName']" :components="getBuilderComponents()" is-section :search-params="searchParams"/>
        </div>
    </div>
</template>
<script lang="ts" setup>
    import { computed, ref, inject } from "vue";
    import Cms from "@/components/Cms.vue";
    import { Link, Head } from "@inertiajs/vue3"
    // import { route } from "ziggy-js";
    import { getBuilderComponents } from "@root/builder-components.ts";
    let route = inject("route");
    let props = defineProps({
        content: {
            type: Object,
            required: true,
            default() {
                return {
                    data: {
                        blogType: "",
                        name: "",
                        metaDescription: "",
                        metaKeywords: ""
                    }
                }
            }
        }
    });

    let builderData = ref({
        blogType: ""
    });
    let url = computed(()=>{
        if(typeof window === "undefined") {
            return "";
        }
        return window.location.href?.replace(window.location.origin, '').replace("/index", '');
    })
    let blogType = computed(()=>{
        return props.content?.data?.blogType?.value?.data?.name ?? builderData.value?.blogType?.value?.data?.name;
    })

    let pageName = computed(()=>{
        return props?.content?.data?.pageName ?? builderData.value?.pageName;
    })

    let searchParams = computed(()=>({
        "data.pageUrl.$eq": url.value
    }))

</script>